import orderService from "@/services/OrderService";

const channelList = {
    namespaced: true,
    state: {
        channels: [],
        loading: false,
    },
    modules: {
    },
    mutations: {
        SET_CHANNELS(state, channels) {
            state.channels = channels
        },
        SET_LOADING(state, loading) {
            state.loading = loading
        }
    },
    actions: {
        load(context) {
            const params = {
                pagination: {page: 1, itemsPerPage: 1000},
                sorting: {sortBy: ["name"], sortDesc: [false]}
            };
            context.commit("SET_LOADING", true);
            return orderService.sources.list(params)
                .then(json => {
                    if (json) {
                        context.commit("SET_CHANNELS", json.items)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => {
                    context.commit("SET_LOADING", false);
                });
        },
    },
    getters: {
        byIri: (state) => (iri) => {
            return state.channels.find(channel => channel['@id'] === iri)
        },
        loading: (state) => {
            return state.loading
        }
    }
};

export default channelList;
